import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DzGridConstants } from '@blk/daisy/util';
import { TealiumConstants } from '@ddt-web/analytics';
import { ApplicationPathConstants } from '@ddt-web/config';
import { SharedApplicationConstants } from '@ddt-web/domain';

import { ModelListRow, ModelRowData } from '../../../models';

@Component({
	selector: 'mb-portfolio-selection-card',
	templateUrl: './portfolio-selection-card.component.html',
	styleUrls: ['./portfolio-selection-card.component.scss']
})
export class PortfolioSelectionCardComponent {
	@Input() public familyData: { [x: string]: any } = {};
	@Input() public portfolioData: Array<ModelRowData> = [];
	@Input() public selectedModelIds: Array<string> = [];
	@Output() public readonly selectedModelsChanged: EventEmitter<ModelListRow> = new EventEmitter<ModelListRow>();
	public isMobile: boolean = window.innerWidth <= DzGridConstants.BREAKPOINTS.sm;
	public appPaths = ApplicationPathConstants.MODELS_BROWSE_PATHS;
	public blkFamilyGroup = SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP;
	public TealiumConstants = TealiumConstants;

	@HostListener('window:resize', ['$event'])
	private onResize(event): void {
		this.isMobile = event.target.innerWidth <= DzGridConstants.BREAKPOINTS.sm;
	}
}
